//
//
//
//
//
//
//
//
//

export default {
  props: {
    contain: {
      type: Boolean,
      default: false,
    },
    lazySrc: {
      type: String,
      required: false,
    },
    src: {
      type: String,
      required: true,
    },
    width: {
      type: [ String, Number ],
      required: true,
    },
    height: {
      type: [ String, Number ],
      required: true,
    },
    lazy: {
      type: Boolean,
      default: true,
      required: false,
    },
    circle: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    realWidth () {
      if (this.fullWidth) {
        return this.$vuetify.breakpoint.width
      }
      return this.width
    },
    realHeight () {
      if (!this.height && this.aspectRatio) {
        return Math.round(this.realWidth / this.aspectRatio)
      }
      return this.height
    },
    realLazySrc () {
      return this.cloudinaryUrl(this.lazySrc)
    },
    realSrc () {
      return this.cloudinaryUrl(this.src)
    },
    imgArgs () {
      const attrs = {
        src: this.realSrc,
      }
      if (this.lazySrc) {
        attrs.style = { backgroundImage: `url(${this.realLazySrc})` }
      }
      if (this.lazy) {
        attrs.loading = 'lazy'
      }
      return attrs
    }
  },
  methods: {
    cloudinaryUrl (src) {
      return src
      // if (!src) {
      //   return src
      // }
      // const isCDNUrl = src.includes('cdn.kintell.com')
      // if (!isCDNUrl && process.env.NODE_ENV === 'development') {
      //   return src
      // }
      // if (src.includes('svg+xml;base64')) {
      //   return src
      // }
      // if (src.startsWith('//')) {
      //   src = 'https://'
      // }
      // const manipulations = [
      //   // use an automatic format, will selectively use webp if the browser supports it
      //   'f_auto',
      //   // apply automatic quality compressions
      //   'q_auto',
      // ]
      // if (this.contain) {
      //   manipulations.push('c_fit')
      // }
      // // crops the image
      // if (this.realWidth && (typeof this.realWidth === 'number' || !this.realWidth.includes('%'))) {
      //   manipulations.push(`w_${this.realWidth}`)
      // }
      // if (this.realHeight && (typeof this.realHeight === 'number' || !this.realHeight.includes('%'))) {
      //   manipulations.push(`h_${this.realHeight}`)
      // }
      // if (this.circle) {
      //   manipulations.push('r_max')
      // }
      // let imageUrl = src
      // if (!isCDNUrl) {
      //   imageUrl = process.env.APP_URL + imageUrl
      // }
      // return `${this.$config.cloudinaryUrl}${manipulations.join(',')}/${imageUrl}`
    }
  }
}
